import { ProjectType } from '../features/projects/ProjectsTable.types';
import { usePostFetch } from '../utils/reactQuery';
import { pathToUrl } from '../utils/router';
import { ApiRoutesEnum } from '../utils/routes';

export type FetchProjectsResponseType = {
  count: number;
  results: ProjectType[];
};

export const useGetAllProjects = () =>
  usePostFetch<FetchProjectsResponseType>(pathToUrl(ApiRoutesEnum.searchProjects), { criteria: [], max: 10000 });
